module.exports = __webpack_public_path__ + "img/serve-country-07.3ce17a1e.png";